import { useState } from "react";
import { useParams, match } from "react-router-dom";
import { Integration } from "../../../models/Entities";
import { MappingTestSuiteMeta } from "../../../models/MappingTests";
import FullPageSpinner from "../../shared/layout/FullPageSpinner";
import AddNewTestSuiteModal from "./AddNewTestSuiteModal";
import MappingTestSuitesTable from "./MappingTestSuitesTable";
import { TableTitleContainer, TableTitleText } from "../../shared/utils/SharedComponentUtils";
import useDocumentTitle from "../../shared/useDocumentTitle";
import { Button } from "@merge-api/merge-javascript-shared";
import { Plus } from "lucide-react";

type RouteParams = {
  integrationID: string;
  operationType: string;
};

type Props = {
  integrationMeta: Integration;
  match: match;
  isLoading: boolean;
  testSuites: MappingTestSuiteMeta[] | undefined;
  setTestSuites: React.Dispatch<React.SetStateAction<MappingTestSuiteMeta[] | undefined>>;
  fetchMappingTestSuites: () => void;
};

const MappingTestSuitesOverview = ({
  integrationMeta,
  isLoading,
  testSuites,
  setTestSuites,
  fetchMappingTestSuites,
}: Props) => {
  const { integrationID } = useParams<RouteParams>();

  useDocumentTitle(`${integrationMeta.name} - Mapping tests`, [integrationMeta.name]);
  const [isAddNewTestSuiteModalOpen, setIsAddNewTestSuiteModalOpen] = useState(false);

  return (
    <>
      <AddNewTestSuiteModal
        integrationMeta={integrationMeta}
        integrationID={integrationID}
        onHide={() => setIsAddNewTestSuiteModalOpen(false)}
        isShown={isAddNewTestSuiteModalOpen}
        fetchMappingTestSuites={fetchMappingTestSuites}
      />
      <TableTitleContainer>
        <TableTitleText>Mapping test suites</TableTitleText>
        <Button onClick={() => setIsAddNewTestSuiteModalOpen(true)} leftIcon={<Plus size={16} />}>
          Add new test suite
        </Button>
      </TableTitleContainer>
      {isLoading || !testSuites ? (
        <FullPageSpinner />
      ) : (
        <MappingTestSuitesTable
          testSuites={testSuites}
          setTestSuites={setTestSuites}
          integrationID={integrationID}
        />
      )}
    </>
  );
};

export default MappingTestSuitesOverview;
